import L from "leaflet";
import { BACKEND } from "./config";
import { getJson } from "./http";

// Basemap Google (ibrida) tramite il proxy del backend legacy.
// Solo in sviluppo: ?basemap=osm usa le tile OpenStreetMap pubbliche.
export async function addGoogleBasemap(map) {
  const devOsm =
    process.env.NODE_ENV === "development" &&
    new URLSearchParams(window.location.search).get("basemap") === "osm";
  if (devOsm) {
    return L.tileLayer("https://tile.openstreetmap.org/{z}/{x}/{y}.png", {
      maxZoom: 21, maxNativeZoom: 19, attribution: "© OpenStreetMap contributors",
    }).addTo(map);
  }
  let url = "/api/google-tiles/{z}/{x}/{y}.png";
  try {
    url = (await getJson(`${BACKEND}/api/config/basemap`)).url || url;
  } catch {
    /* config non raggiungibile: si usa il percorso di default */
  }
  return L.tileLayer(`${BACKEND}${url}`, {
    maxZoom: 21, maxNativeZoom: 20, attribution: "© Google",
  }).addTo(map);
}

// Mirino per il punto cercato o cliccato (motivo "reticle" del design system).
export const reticleIcon = L.divIcon({ className: "sm-reticle", iconSize: [22, 22] });
